import React, { useState, useContext, useEffect } from "react";
import { useForm, Controller, set } from "react-hook-form";
import { getAttendantInfo } from "../../api/apiManagement";
import { countries, locations } from "../../data/Data";
import { mobileSchema } from "../../models/ValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { StaffPortalContext } from "./StaffPortal";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
  InputLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";

const SearchMobilePage = () => {
  const {
    register,
    handleSubmit,
    control,
    setError,
    getValues,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      select: { value: "852", label: "+852" },
      mobile_number: "",
    },
    resolver: yupResolver(mobileSchema),
  });

  const { setCurrentStep, data, setData } = useContext(StaffPortalContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setData({});
  }, []);

  const onSubmit = async (d) => {
    console.log(d);
    const searchMobile = d?.select?.value + d?.mobile_number;
    console.log(searchMobile);
    setIsLoading(true);
    getAttendantInfo({ phone: searchMobile })
      .then((res) => {
        const currentStatus = res.data.status;

        if (currentStatus === "200") {
          setData(res.data.data);
          setCurrentStep(2);
        }
        if (currentStatus === "301") {
          setError("mobile_number");
        }
        console.log(res);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}
      >
        Search customer mobile<br></br>搜尋流動電話號碼
      </Typography>
      <Box
        sx={{
          width: "100%",
          marginRight: "20px",
          marginBottom: "30px",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Controller
              control={control}
              name="select.value"
              render={({ field }) => (
                <Select
                  error={!!errors.mobile_number}
                  {...field}
                  labelId="country-code-label"
                  displayEmpty
                  defaultValue={countries[0].value}
                  variant="standard"
                  disabled={isLoading}
                  onChange={(event) => field.onChange(event.target.value)}
                >
                  {countries.map((country) => (
                    <MenuItem key={country.value} value={country.value}>
                      {country.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            <TextField
              fullWidth
              variant="standard"
              inputProps={{}}
              error={!!errors.mobile_number}
              disabled={isLoading}
              {...register("mobile_number")}
            />
          </Box>
        </Box>
        {errors.mobile_number && (
          <FormHelperText error>No record 沒有資料</FormHelperText>
        )}
      </Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <LoadingButton
          type="submit"
          variant="outlined"
          onClick={handleSubmit(onSubmit)}
          sx={{ borderRadius: "30px", lineHeight: "20px", width: "140px" }}
          disabled={isLoading}
        >
          SEARCH<br></br> 搜尋
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default SearchMobilePage;
